import { FC, ReactElement } from 'react';
import { Chip, useTheme } from '@mui/material';
import { TCustomTheme } from '@mgm/common/theme';
import { useAppSelector } from '../../hooks/useAppStore';
import { getTokenDetails } from '../../store/authenticate/selectors';

type TBaseChip = {
  size?: 'small' | 'medium'
  label: string
  fontSize?: number
  icon?: ReactElement
  color?: string
  fontWeight?: number
};

const BaseChip: FC<TBaseChip> = ({
  size = 'small',
  label,
  fontSize = 11,
  icon,
  color = '#A78BFA',
  fontWeight = 500,
}) => {
  const tokenDetails = useAppSelector(getTokenDetails);
  const isDark = tokenDetails?.settings?.ui?.theme === 'dark';
  const theme = useTheme() as TCustomTheme;

  return (
    <Chip
      size={size}
      {...(isDark && {
        variant: 'outlined',
      })}
      sx={{
        '& .MuiChip-label': {
          color,
          fontSize,
          fontWeight,
        },
        ...(isDark && {
          bgcolor: theme.palette.primary.hover,
        }),
        ml: 1,
      }}
      icon={icon}
      label={label}
    />
  );
};

export {
  BaseChip,
};
